import { IData } from '../interface';

const renderSentry = (data: IData, SYSTEM: string) => {
    let cdn = 'https://d1bvk99i2a79wx.cloudfront.net/statics/js/bundle.tracing.min.js';
    let dsn = 'https://3ee9857afe7345c8b5d6c484667a1a82@sentry.umu.com/4';
    if (SYSTEM === 'TW' || SYSTEM === '"TW"') {
        cdn = 'https://d1yemi1ss2f2oh.cloudfront.net/statics/js/bundle.tracing.min.js';
        dsn = 'https://3c30774713ac402fbe62cf5d4ff30886@sentry.umu.tw/4';
    } else if (SYSTEM === 'JP' || SYSTEM === '"JP"') {
        cdn = 'https://dpfrzbu0cqnmm.cloudfront.net/statics/js/bundle.tracing.min.js'
    }
    return `
        <script src="${cdn}"
            type="text/javascript"></script>
        <script type="text/javascript">
        if (window.Sentry) {
            Sentry.init({
                dsn: "${dsn}",
                integrations: [
                    new Sentry.Integrations.BrowserTracing(),
                    new Sentry.Integrations.GlobalHandlers({
                        onunhandledrejection: true,
                        onerror: true,
                    }),
                ],
                ignoreErrors: [
                    "AbortError: The operation was aborted.",
                    "No error message",
                    "The network connection was lost.",
                    "Failed to fetch",
                    "網路連線中斷。",
                    "已取消",
                    "Internet連線已斷開。",
                  ],
                denyUrls: [/extensions/i, /^chrome:/i],
                release: ${data.VERSION},
                tracesSampleRate: 1.0,
            })
        }
        </script>
    `;
};

export default renderSentry;
